import Select from 'react-select';

const SelectItems = ({ dataset, items, setItems, add, destroy }) => {
    const change = async data => {
        let operation = true;
        if (data > items) {
            const new_item = data.find(item => !items.includes(item));
            operation = await add(new_item);
        } else if (data < items) {
            const old_item = items.find(item => !data.includes(item));
            operation = await destroy(old_item);
        }
        if (operation) setItems([...data])
    }

    return <Select
                isMulti
                onChange={change}
                options={dataset}
                value={items}
                className='react-select-container'
                classNamePrefix="react-select"
            />

}

export default SelectItems;